import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import makeStyles from '@mui/styles/makeStyles';
import { ArrowBackOutlined, ArrowForwardOutlined } from '@mui/icons-material';
import ProfileImg from '../../../assets/images/placeholder.png' //image

const useStyles = makeStyles({
    mainDiv:{
        width:'calc(100% - 20px)',
        justifyContent:'space-between',
        borderRadius:'5px',
        backgroundColor:'#fff',
        padding:'40px 10px',
        marginBottom:'30px',
        boxShadow:'0px 1px 2px #00000038',
        position:'relative'
    },

    mainDiv2:{
        width:'100%',
        maxHeight:'550px',
        overflow:'auto',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        '&::-webkit-scrollbar': {
            width: '2px!important',
            height: '2px!important'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor:'hsla(0,0%,100%,.1)',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.2)',
        }
    },

    imgDiv:props=> ({
        width:'70px',
        height:'70px',
        borderRadius:'50%',
        backgroundColor: props.backgroundColor ? props.backgroundColor : '#0F467A',
        "& img":{
            width:'100%',
            height:'100%',
            borderRadius:'50%',
        }
    }),

    role:props=> ({
        fontSize:'15px',
        color: props.fontDarkColor ? props.fontDarkColor : '#0F467A',
        textTransform:'capitalize'
    }),
    
    teamDiv:{
        display:'flex',
        flexDirection:'column',
        alignItems: 'center',
        padding:"0px 5px 10px 5px",
        "& span":{
            color:'#0F467A',
            textTransform:'capitalize'
        }
    },

    memberName:{
        fontSize:'12px',
        padding:'5px 0px',
        fontWeight:'bold',
        textTransform:'capitalize',
        textAlign:'center',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },

    scrollBtn:{
        width:'40px',
        height:'40px',
        borderRadius:'50%',
        backgroundColor:'rgba(0,0,0,0.35)',
        position:'absolute',
        top:"40%",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor:'pointer',
        color: '#fff'
    },

    leftDiv:{
        left:0
    },
    rightDiv:{
        right:0
    },

    marLeft:{
        marginLeft:'10px'
    },
    marRight:{
        marginRight:'10px'
    }
});

// Team section
function TeamSection(props) {
    const isMounted = React.useRef(null);
    const [showScroll,setShowScroll] = React.useState(false);

    useEffect(()=> {
        // check if there is scroll width show scroll buttons
        const checkScroll = () => {
            isMounted.current = true;
            let scrollDiv = document.getElementById('scrollDiv');
            var width= scrollDiv && scrollDiv.offsetWidth,
            scrollWidth= scrollDiv.scrollWidth;
            if(scrollWidth > width) {
                if(isMounted.current) setShowScroll(true);
            }
        }
        checkScroll()
        return () => {
            isMounted.current = false;
        }
    })

    const scrollEvent = (direction) => { // scroll left/right on button click
        if(direction === 'left') {
            let scrollDiv = document.getElementById('scrollDiv');
            scrollDiv.scrollLeft += 150
        };
        if(direction === 'right') {
            let scrollDiv = document.getElementById('scrollDiv');
            scrollDiv.scrollLeft -= 150
        }
    }

    const { fontDarkColor, i18n, teams, backgroundColor,reference } = props;
    const classes = useStyles({fontDarkColor,backgroundColor});
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <div className={classes.mainDiv} ref={reference}>
            <div className={classes.mainDiv2} id='scrollDiv'>
                {React.Children.toArray(teams.map(v=> {
                    return(
                        <div className={`${classes.teamDiv} ${isRTL === 'ar' ? classes.marLeft : classes.marRight}`}>
                            <div className={classes.imgDiv}>
                                <ImgLazyLoad>
                                    <img src={ProfileImg} alt='team' />
                                </ImgLazyLoad>
                            </div>
                            <span className={classes.memberName} style={{fontFamily,color:'#000'}}>{v.name}</span>
                            <span style={{fontFamily}}>{v.roleType}</span>
                        </div>
                    )
                }))}
            </div>
            {/* scroll buttons */}
            {showScroll ?
                <>
                    <div className={`${classes.scrollBtn} ${classes.leftDiv}`} onClick={()=> scrollEvent('right')}><ArrowBackOutlined /></div>
                    <div className={`${classes.scrollBtn} ${classes.rightDiv}`} onClick={()=> scrollEvent('left')}><ArrowForwardOutlined /></div>
                </>
            :
                undefined
            }
        </div>
    )
}

export default withTranslation('common')(TeamSection);